














































































































import { Component, Prop, Vue } from "vue-property-decorator";

// Types
import { ILead } from "@/models/leads";
import { mapGetters } from "vuex";

@Component({
  components: {
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class LeadURippleTableRow extends Vue {
  @Prop({ required: true })
  public lead!: ILead;

  @Prop({ default: false })
  public showRelatedLeadsCount!: boolean;

  @Prop({ default: false })
  public showMainLabel!: boolean;

  //Data
  public isMultibrand!: boolean;
  public canViewLead = this.$userCan("get_lead");
  public canDeleteLead = this.$userCan("delete_lead");
  public canUpdateLead = this.$userCan("update_lead");
  public canCreateTicket = this.$userCan("create_ticket");

  public get hasRelatedLeads() {
    return !!this.$_.get(this.lead, "related_leads.length", 0);
  }
}
